import i from "react";
import { translate as t } from "@aws-amplify/ui";
import { useAuthenticator as n } from "@aws-amplify/ui-react-core";
import { Button as o } from "../../../primitives/Button/Button.js";
import { Flex as e } from "../../../primitives/Flex/Flex.js";
const r = () => {
  const {
    isPending: r,
    toSignIn: m
  } = n(i => [i.isPending, i.toSignIn]);
  return i.createElement(e, {
    direction: "column"
  }, i.createElement(o, {
    isDisabled: r,
    type: "submit",
    variation: "primary",
    fontWeight: "normal",
    isLoading: r,
    loadingText: t("Confirming")
  }, t("Confirm")), i.createElement(o, {
    onClick: m,
    type: "button",
    variation: "link",
    fontWeight: "normal",
    size: "small"
  }, t("Back to Sign In")));
};
export { r as ConfirmSignInFooter };